import { onRequest, RequestMethod } from "common/axios/axios"
import { MESSAGE } from "./types/MESSAGE.types"
import { getApiUrl } from "common/axios/getApiUrl"
import { getServiceId } from "common/service"

export class NotificationRepository {
    static onPostPushHist = (params: MESSAGE.PostPushHistParams) => {
        return onRequest({url: getApiUrl('notifications'), method: RequestMethod.POST, params: {...params, serviceId: getServiceId()}})
    }
}